import React, { useState } from "react";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {Button, Col, Row, Space} from "antd";
import { AddressListModal } from "./address-list.modal";
import { AddressListCard } from "./address-list.card";
import {BranchAddress, BranchAddressRequestValues} from "../../../../../models/branches/branch-data";

interface AddressListProps {
    addresses: BranchAddress[];
    create?: (values: BranchAddressRequestValues) => Promise<any>;
    edit?: (values: BranchAddressRequestValues, item?: BranchAddress) => Promise<any>;
    remove?: (item: BranchAddress) => Promise<any>;
    defaultId?: number;
    setDefault?: (item: BranchAddress) => Promise<any>;
}

export const AddressList: React.FC<AddressListProps> = ({addresses, create, edit, remove, defaultId, setDefault}) => {

    const t = useTranslate();
    const [isModalShown, setModalShown] = useState<boolean>(false);

    return (
        <Space direction="vertical" size={[20, 20]}>
            {create ? (
                <Button
                    onClick={() => setModalShown(true)}
                    type="primary"
                >
                    {t("ADD")}
                </Button>
            ) : null}
            <Row gutter={[30, 30]}>
                    {addresses.map((item) => (
                            <Col
                                className={"card-col"}
                                key={item.id}
                                xxl={8}
                                xl={8}
                                lg={8}
                                md={12}
                                sm={24}
                                xs={24}
                            >
                                <AddressListCard
                                    address={item}
                                    edit={edit}
                                    remove={remove}
                                    isDefault={defaultId === item.id}
                                    setDefault={setDefault}
                                />
                            </Col>
                        ))}
                </Row>
                {create && isModalShown ? (
                    <AddressListModal
                        onSubmit={(values) => create(values)}
                        onClose={() => setModalShown(false)}
                    />
                ) : null}
        </Space>
    );
}
